import { SubTitle } from 'components/text/SubTitle';
import { Button, CalendarInput, Tabs, TextInput, Typography } from 'enable-ui';

import { HeaderDetailPage } from 'modules/dashboard/components/HeaderDetailPage';

import { CustomTabs } from '../styles/tab';

import { isBefore } from 'date-fns';
import { orderBy } from 'lodash';

import { COLOR_CONFIG } from 'constants/color';

import { FunctionalTestTable } from '../components/FunctionalTest';
import { LearnResult } from '../components/LearnResult';
import { getFunctionalTestColumn } from '../core/columns';
import { useAssessmentDetailController } from '../core/controller/assessment-detail';
import { ASSESSMENT, LessonAssessmentType } from '../core/enum';
import { getAssessmentTabs } from '../core/tabs';

export const AssessmentDetail = () => {
  const {
    activeKey,
    onTabClick,
    learnerResult,
    functionTests,
    assessment,
    values,
    handleChange,
    handleSubmit,
    disabled,
    handleChangeDate,
    goBack,
  } = useAssessmentDetailController();

  const tabs = getAssessmentTabs();

  const functionalTestColumns = getFunctionalTestColumn();

  const date = (values?.date ? new Date(values.date) : '') as Date;

  const isDateBefore = isBefore(date, new Date());

  const disabledDateTimePicker = isDateBefore && !!assessment?.start && !!assessment?.end;

  const [startTime] = values?.start?.split(':') ?? '';
  const [endTime] = values?.end?.split(':') ?? '';
  const invalidDuration = !!startTime && !!endTime && Number(startTime) >= Number(endTime);

  return (
    <div>
      <HeaderDetailPage
        title={
          <div>
            <Typography variant="h3" weight={700}>
              {assessment?.name}
            </Typography>
            {assessment?.isClass && assessment?.isOnboarding ? (
              <SubTitle leftTitle="Onboarding" rightTitle="Class" />
            ) : (
              <Typography style={{ fontSize: '16px', lineHeight: '22px', color: '#808080' }}>
                {assessment?.isClass ? 'Class assessment' : 'Baseline fitness test'}
              </Typography>
            )}
          </div>
        }
        goBack={goBack}
      />

      <div
        style={{
          margin: '16px 0',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div className="wrapper-calendar-input" style={{ width: '30%' }}>
            <CalendarInput
              date={date}
              onChange={handleChangeDate}
              dropdownConfig={
                disabledDateTimePicker
                  ? {
                      dropdownConfig: {
                        disabled: disabledDateTimePicker,
                      },
                    }
                  : undefined
              }
              disabled={disabledDateTimePicker}
            />
          </div>

          <div style={{ display: 'flex', width: '40%', gap: 12 }}>
            <TextInput
              type="time"
              containerStyle={{
                maxWidth: 'auto',
              }}
              value={values.start}
              disabled={!date || disabledDateTimePicker}
              onChange={handleChange}
              name="start"
            />
            <TextInput
              type="time"
              containerStyle={{
                maxWidth: 'auto',
              }}
              value={values.end}
              disabled={!date || disabledDateTimePicker}
              onChange={handleChange}
              name="end"
            />
          </div>
          <Button color="primary" disabled={disabled} onClick={() => handleSubmit()}>
            Save
          </Button>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 6 }}>
          <div style={{ width: '30%' }}></div>
          <div style={{ width: '40%' }}>
            {invalidDuration ? (
              <Typography color={COLOR_CONFIG.red}>Invalid duration</Typography>
            ) : null}
          </div>
          <div></div>
        </div>
      </div>
      <div
        className={`border-container p-16 pt-0 ${activeKey === ASSESSMENT.RESULT ? '' : 'py-0'}`}
      >
        <CustomTabs>
          <Tabs
            items={tabs}
            activeKey={activeKey}
            onTabClick={onTabClick}
            tabItemStyle={{
              height: 52,
              background: 'transparent',
              width: '50%',
              display: 'flex',
              justifyContent: 'center',
              padding: 0,
            }}
            isLine={true}
          />
        </CustomTabs>
        <div style={{ marginTop: 16 }}>
          {activeKey === ASSESSMENT.RESULT ? (
            <LearnResult
              type={LessonAssessmentType.ASSESSMENTS}
              learnerResults={learnerResult}
              completedOn={assessment?.completedOn}
            />
          ) : (
            <FunctionalTestTable
              columns={functionalTestColumns}
              data={orderBy(functionTests, 'index')}
            />
          )}
        </div>
      </div>
    </div>
  );
};
